module.exports = __webpack_public_path__ + "static/media/astro_hang_gliding.d246b1a7.png";